import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import OfferForm from "../../OfferForm";

const InfoStep = ({ schema, eventTargets, values, ...rest }) => {
  const templateType = get(values, "offer_template.id");

  return (
    <OfferForm
      eventTargets={templateType === "event" ? eventTargets : []}
      values={values}
      {...rest}
    />
  );
};

InfoStep.propTypes = {
  schema: PropTypes.object,
  values: PropTypes.shape({
    offer_template: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  }),
  eventTargets: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
};

InfoStep.defaultProps = {
  eventTargets: [],
  values: {},
};

export default InfoStep;
